import { types as t } from 'mobx-state-tree';
import { AbstractQuestionWithMultipleOption } from '../abstract-question-multiple-option.store';

export const MatchingParagraphAnswerQuestion = AbstractQuestionWithMultipleOption.named(
  'MatchingParagraphAnswerQuestion'
).props({
  paragraphKeys: t.array(t.number),
});
